import React from 'react'

function Live() {
    return (
        <div>
            <h1>Go Live</h1>
        </div>
    )
}

export default Live
